<template>
  <v-container>
      Whatcha doin here
  </v-container>
</template>

<script>
export default {
    name: 'Callback',
    mounted() {
        localStorage.setItem("message", JSON.stringify(this.processHash(location.hash)));
        localStorage.removeItem("message");
        window.close();
    },
    methods: {
        processHash: hash => {
            hash = hash.slice(1).split('&');
            let newObj = {};
            for(let i = 0; i < hash.length; i++) {
                const splitted = hash[i].split('=');
                newObj[splitted[0]] = splitted[1];
            }
            return newObj;
        }
    }
}
</script>

<style>

</style>